module.exports = __webpack_public_path__ + "img/bio-image.30740c81.jpg";